<template>
    <scrum-board></scrum-board>
</template>

<script>

    import ScrumBoard from './scrumboard/ScrumBoard'

    export default {
        props: [],
        components: {
            ScrumBoard
        },
        data: function () {
            return {
                
            }
        },
        mounted: function() {

        },
        computed: {
            
        },
        methods: {
            
        }
    }
</script>